import React from 'react';
import { Box, Heading, Link, VStack, Text } from '@chakra-ui/react';

const Certifications = ({ bg, color }) => (
    <Box id="certifications" p={5} bg={bg} borderRadius="lg" boxShadow="md">
        <Heading as="h2" size="lg" color={color}>Certifications</Heading>
        <VStack align="start" mt={4}>
            <Text color={color}>The Complete Web Developer, Udemy </Text>
            <Link href="https://www.udemy.com/certificate/UC-eff953b9-1ed4-47aa-acca-324925e65fbb/" color="teal.500" isExternal>View Certification</Link>
            <Text color={color}>Web Development, 1Stop in collaboration with Techfest, IIT Bombay </Text>
            <Link href="https://drive.google.com/file/d/1-5ONl4yMl9jhT-34i9cEdGscJcf-Vi6I/view" color="teal.500" isExternal>View Certification</Link>
        </VStack>
    </Box>
);

export default Certifications;
